<template>
  <section
    class="global-toast"
    :class="`global-toast--${props.type}`"
    @click="handleDeletionOfToast()"
  >
    <v-icon
      class="global-toast__icon"
      :class="`global-toast__icon--${props.type}`"
      :icon="correctIcon"
    ></v-icon>
    <div class="global-toast__body">
      <h3 class="text-base">{{ props.title }}</h3>
      <p class="text-xs">{{ props.content }}</p>
    </div>
    <v-icon
      class="global-toast__icon global-toast__icon--close"
      :class="`global-toast__icon--${props.type}`"
      icon="times"
    ></v-icon>
  </section>
</template>

<script setup>
import { computed, inject, onMounted } from "vue";

const props = defineProps({
  type: String,
  title: String,
  content: String,
  timestamp: Number,
});

const toastEvents = inject("toastEvents");

const correctIcon = computed(() => {
  if (props.type == "info") {
    return "circle-info";
  } else if (props.type == "negative") {
    return "circle-xmark";
  } else {
    return "circle-check";
  }
});

onMounted(() => {
  setTimeout(() => {
    handleDeletionOfToast();
  }, 4500);
});

function handleDeletionOfToast() {
  toastEvents.splice(
    toastEvents
      .map((x) => {
        return x.id;
      })
      .indexOf(props.timestamp),
    1
  );
}
</script>

<style scoped>
.global-toast {
  display: flex;
  cursor: pointer;
  border-radius: 8px;
  width: 320px;
  margin-bottom: 10px;
  padding: var(--space-10) var(--space-20);
}
.global-toast--positive {
  background-color: var(--primary-100);
  border: 1px solid var(--primary-600);
}

.global-toast--negative {
  background-color: var(--red-100);
  border: 1px solid var(--red-950);
}

.global-toast--info {
  background-color: var(--blue-100);
  border: 1px solid var(--blue-900);
}

.global-toast__body {
  margin-left: var(--space-10);
}
.global-toast__body h3 {
  margin: 0;
  font-weight: var(--weight-medium);
}
.global-toast--positive h3 {
  color: var(--primary-900);
}
.global-toast--negative h3 {
  color: var(--red-950);
}
.global-toast--info h3 {
  color: var(--blue-900);
}

.global-toast--positive p {
  color: var(--primary-600);
}
.global-toast--negative p {
  color: var(--red-650);
}
.global-toast--info p {
  color: var(--blue-600);
}

.global-toast__body p {
  margin: 0;
  font-weight: var(--weight-semibold);
}
.global-toast__icon {
  margin-top: var(--space-4);
}

.global-toast__icon--positive {
  color: var(--primary-600);
}
.global-toast__icon--negative {
  color: var(--red-650);
}
.global-toast__icon--info {
  color: var(--blue-600);
}

.global-toast__icon--close {
  margin-left: auto;
}
</style>
